/**
* @Description: VIP_V4_OPEN
* @author XuZiYu
* @date 2021/12/08 10:02:27
* @update 2022/08/09 ZhanFuzheng 样式变更 新增用户体验 当可视区域离开中间的切换商品时候 底部商品选项将展示出来
* @update 2022/08/30 ZhanFuzheng 获取车型方式调整
* @update 2025/04/3 ZhanFuzheng 增加会员协议
*/
<template>
    <div :class="['wrapper-open',iphonePayCourseVisible && 'no-scroll']">

        <!--头部-->
        <template v-if="!H5 && headVisible !== '0'">
            <div class="header">
                <div class="header-left" @click="goBack"><img src="@/assets/vip/icon_back1.png" alt=""/></div>
                <div class="header-main">科一科四VIP题库</div>
                <div class="header-share" v-if="shareVisible" @click="openSharePanel">
                    <img src="@/assets/public/icon_fx01.png" alt=""></div>
                <div class="header-right" v-if="!H5" @click="callPhone">
                    <img src="@/assets/vip/icon_customerservice1.png" alt=""></div>
            </div>

            <!--头部占位-->
            <div class="header-pre"></div>
        </template>

        <!--分享框架-->
        <share-ad :detail="shareData">
            <div class="bg">
                <div class="bg-item">
                    <img src="@/assets/vipV3/picture_viptk01_2.png" alt=""/>
                    <!-- 题库 套餐切换按钮 -->
                    <div v-if="vipData.vipPackageShowFlag" class="goods">
                        <div class="goods-item active">
                            <h4 class="goods-item__title">VIP题库</h4>
                            <div class="goods-item__price" v-if="openData.payConPrice">
                                ¥<span>{{openData.payConPrice > 0 ? openData.payConPrice : openData.payOrigPrice}}{{openData.payConPoint ? ` + ${openData.payConPoint}斑豆` : ''}}</span>
                                {{`${Number(openData.effectiveDays) === 365 ? '/年':  `/${openData.effectiveDays}天`}`}}</div>
                            <p class="goods-item__intro">科一科四轻松学</p>
                        </div>
                        <div class="goods-item" @click="goVipPackage">
                            <img class="goods-item__heat" src="@/assets/vipV3/icon_xsrm.png" />
                            <h4 class="goods-item__title">VIP套餐</h4>
                            <div class="goods-item__price" v-if="vipData.examVipPackageMatchEntryDTO">
                                ¥<span>{{vipData.examVipPackageMatchEntryDTO.examVipSettingDTO.payConPrice > 0 ? vipData.examVipPackageMatchEntryDTO.examVipSettingDTO.payConPrice : vipData.examVipPackageMatchEntryDTO.examVipSettingDTO.payOrigPrice}}{{vipData.examVipPackageMatchEntryDTO.examVipSettingDTO.payConPoint ? ` + ${vipData.examVipPackageMatchEntryDTO.examVipSettingDTO.payConPoint}斑豆` : ''}}</span>
                                {{`${Number(vipData.examVipPackageMatchEntryDTO.examVipSettingDTO.effectiveDays) === 365 ? '/年':  `/${vipData.examVipPackageMatchEntryDTO.examVipSettingDTO.effectiveDays}天`}`}}</div>
                            <p class="goods-item__intro">科一科四+科三优惠</p>
                        </div>
                    </div>
                </div>
                <div ref="detail-item" class="detail-item">
                    <div class="detail-item-wrap">
                        <span class="detail-click" @click="goDetail(1)"></span>
                        <span class="detail-click" @click="goDetail(2)"></span>
                        <span class="detail-click" @click="goDetail(3)"></span>
                        <span class="detail-click" @click="goDetail(4)"></span>
                        <span class="detail-click" @click="goDetail(5)"></span>
                        <span class="detail-click" @click="goDetail(6)"></span>
                        <span class="detail-click" @click="goDetail(7)"></span>
                        <span class="detail-click" @click="goDetail(8)"></span>
                        <span class="detail-click" @click="goDetail(9)"></span>
                        <span class="detail-click" @click="goDetail(10)"></span>
                        <span class="detail-click" @click="goDetail(11)"></span>
                        <span class="detail-click new" @click="goDetail(12)"></span>
                    </div>
                    <img src="@/assets/vipV3/picture_viptk02n.png" alt=""/>
                </div>
                <img src="@/assets/vipV3/picture_viptk03n.png" alt=""/>
               <div class="video-wrap">
                   <img src="@/assets/vipV3/picture_viptk04n.png" alt=""/>
                   <img src="@/assets/vipV3/video.gif" alt=""/>
                   <img src="@/assets/vipV3/icon_bfspan.png" />
               </div>
                <img src="@/assets/vipV3/picture_viptk05.png" alt=""/>
                <img src="@/assets/vipV3/picture_viptk06.png" alt=""/>

                <img v-if="openData.ensureFlag" src="@/assets/vipV3/picture_viptk07.png" alt=""/>
            </div>
            <div class="rule">
                <img class="rule-title" src="@/assets/vipV3/icon_cjwt01.png" alt="">
                <div class="rule-item">
                    <div class="rule-item-title">科一&科四VIP课程包含哪些权益，适合哪些用户?</div>
                    <div class="rule-item-content">科一&科四理论速成包含精选必做500题、考前秘卷、智能练题、预测通过率多项权益。小车C1、C2的学员都适用，帮助您快速通过科一 &科四考试。</div>
                </div>
                <div class="rule-item">
                    <div class="rule-item-title">有效期从什么时候开始算?</div>
                    <div class="rule-item-content">VIP服务有效期从您购买之日算起，有效期<b>{{openData.effectiveDays}}</b>天</div>
                </div>
                <div class="rule-item">
                    <div class="rule-item-title">我刚开通VIP为什么消失或者未生效?</div>
                    <div class="rule-item-content">请检查是否已经登录了账号，购买成功后,需要登录您的账号才能享受VIP服务。</div>
                </div>
                <div class="rule-item">
                    <div class="rule-item-title">VIP 购买后可以退款吗?</div>
                    <div class="rule-item-content">VIP是虚拟商品，不支持退款哦。</div>
                </div>
                <div class="rule-item" v-if="openData.ensureFlag">
                    <div class="rule-item-title">为什么考不过却无法申请现金补偿？</div>
                    <div class="rule-item-content">① 考试日期不在VIP有效期内；
                        ② 缺考不能申请补偿；
                        ③ 科一或科四的成绩分数在60-89分之间，才可申请补偿；
                        ④参加公安局车管所举办的驾驶员考试（机动车驾驶员考试）前一天激活保障卡，如当天激活，不能申请补偿；
                        ⑤如果提交资料不正确（如：姓名，122网站密码等）会被审核人员驳回且将影响您获得补偿的进度；
                        ⑥如果您考试没通过，在还未获取补偿之前再次预约考试，您新的预约会覆盖之前122网站上原来的挂科成绩，审核人员查不到成绩分数，也会导致您申请补偿失败。
                    </div>
                </div>
                <div class="rule-item">
                    <div class="rule-item-title">其他问题及注意事项</div>
                    <div class="rule-item-content">购买前请注册/登录App账号，购买成功后，需要登录您购买时的账号才能享受VIP服务。如遇问题，可直接联系右上角帮助中的在线客服或者拨打客服电话咨询，我们会及时为您解答。
                    </div>
                </div>
            </div>
            <div class="tips">
                <div class="mamber-info">开通前请阅读<span class="pay-course" @click="handleOpenMember">《会员协议》</span></div>
                <div v-if="IOS" class="pay-course" @click="iphonePayCourseVisible = true">iPhone支付教程</div>
            </div>
            
        </share-ad>

        <!--vip套餐切换-->
        <template v-if="false">
            <div class="change-page fade" :class="[isShowFooter?'show':'hide']">
                <div class="item">
                    <span class="f-s-18">VIP题库</span>
                    <span class="f-s-15" v-if="openData.payConPrice">¥{{openData.payConPrice}}</span>
                    <img class="icon-active" src="@/assets/vipV3/icon_yx.png" alt="">
                </div>
                <div class="item" @click="goVipPackage">
                    <span class="f-s-18">VIP套餐</span>
                    <span class="f-s-15" v-if="vipData.examVipPackageMatchEntryDTO">¥{{vipData.examVipPackageMatchEntryDTO.examVipSettingDTO.payConPrice}}</span>
                    <img class="icon-xsrm" src="@/assets/vipV3/icon_xsrm.png" alt="">
                </div>
            </div>

            <!--vip套餐切换占位-->
            <div class="change-page-pre"></div>
        </template>

        <!--底部-->
        <div class="footer">
            <span v-if="openData.openMode === 1" class="second">
                限时领取 <b>（分享激活）</b>
            </span>
            <span v-else class="first">
                <span class="flag">VIP题库</span>
                <span class="money">
                    <b v-if="openData.openMode === 3" class="left">{{openData.pointNum}}斑豆</b>
                    <b v-if="openData.openMode === 2" class="left">¥{{openData.payConPrice > 0 ? openData.payConPrice : openData.payOrigPrice}}{{openData.payConPoint ? ` + ${openData.payConPoint}斑豆` : ''}}</b>
                    <b class="main">{{`${Number(openData.effectiveDays) === 365 ? '/年':  `/${openData.effectiveDays}天`}`}}</b>
                    <b v-if="openData.openMode === 2 && openData.payConPrice > 0" class="right">¥{{openData.payOrigPrice}}</b>
                </span>
            </span>

            <!--车型判断是否显示购买按钮-->
            <template v-if="Number(carType) === 1">
                <van-button class="fourth" @click="submit" :loading="loading">立即开通</van-button>
            </template>

            <template v-else>
                <div class="btn-none-buy">仅适用于C1/C2学员</div>
            </template>
        </div>

        <!--底部占位-->
        <div class="footer-pre"></div>

        <!--消息弹出框-->
        <ctl-dialog v-model="messageDialog" :loading="loading"/>
        <iphonePayCourse v-if="iphonePayCourseVisible"></iphonePayCourse>
    </div>
</template>

<script>
import dialog from '@/components/dialog'
import iphonePayCourse from '@/views/iphonePayCourse'
import { Toast, Button } from 'vant'

export default {
    name: 'vipV4Open',
    components: {
        ctlDialog: dialog,
        [Button.name]: Button,
        iphonePayCourse: iphonePayCourse
    },
    props: ['vipData', 'userInfo', 'carType', 'cityCode'],
    methods: {
        // 返回
        goBack () {
            this.$jsBridge.callBackHandler('returnLastPage')
        },
        // 拨打客服电话
        callPhone () {
            this.$jsBridge.callBackHandler('pushCusService')
        },
        // 打开分享面板
        openSharePanel () {
            // 标题
            let title = this.shareData.shareTitle || 'VIP题库'
            // 内容
            let content = '掌握一题=练习多题，轻松搞定科一&科四！'
            // 分享链接
            let shareUrl = ''
            // 图片链接
            let imageUrl = this.shareData.shareGroupImg
            // 页面编码
            let pageCode = 'question-bank'

            if (this.shareData.shareType === '1') {
                // 处理域名替换
                shareUrl = location.origin.replace('app.banbanjiadao.com', 'app.banbanjd.cn').replace('app.chetailian.com', 'app.banbanjd.cn')

                // 拼接路径
                shareUrl += location.pathname

                // 拼接参数
                shareUrl += `?shareType=h5&appType=${this.appType}&cityCode=${this.cityCode}`

                // 设置图片链接
                imageUrl = this.shareData.shareImg || 'http://app.static.public.chetailian.com/share/VIPtk.png'
            }

            // 唤起分享
            this.$jsBridge.callBackHandler('share', { title, content, shareUrl, imageUrl, pageCode })
        },
        // 跳转app
        linkApp () {
            // 判断设备
            if (this.IOS) {
                // qq浏览器特殊处理
                if (String(navigator.userAgent.toLowerCase().match(/QQ/i)) === 'qq') {
                    let body = document.querySelectorAll('body')[0]
                    let div = document.createElement('div')
                    let img = document.createElement('img')
                    div.style = 'width: 100%;position: fixed;height: 100%;top: 0;background: rgb(0 0 0 / 80%);z-index: 9;'
                    div.onclick = () => {
                        body.removeChild(div)
                    }
                    img.src = require('@/assets/public/icon_fxts.png')
                    img.style = 'width:100%'
                    div.appendChild(img)
                    body.appendChild(div)
                    return true
                }

                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://share.banbanjiadao.com/ui/h5/bbjd/index'
                    : 'https://share.banbanjiadao.com/ui/h5/bb/index'
            } else {
                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://a.app.qq.com/o/simple.jsp?pkgname=com.banbanjiadao.activity&android_schema=banbanjiadao%3a%2f%2fopen'
                    : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ctl.student&android_schema=chetailian%3a%2f%2fopen&ios_scheme=chetailian%3a%2f%2fopen'
            }
        },
        // 跳转八大权益
        goDetail (v) {
            this.$router.push({
                name: 'vipIntroduce',
                query: {
                    ...this.$route.query,
                    type: v,
                    webview: '0'
                }
            })
        },
        // 斑豆开通方式
        beanOpenModel () {
            // 斑豆开通需要登陆
            if (!this.userInfo.userId) {
                this.$jsBridge.callBackHandler('loginUserV2')
                return
            }

            this.messageDialog = {
                visible: true,
                rightBtnName: '确认',
                leftBtnName: '取消',
                leftBtnMethod: () => {
                    this.messageDialog.visible = false
                },
                rightBtnMethod: () => {
                    this.loading = true
                    this.$api.bbBeanOpen({ currentUserId: this.userInfo.userId }).then(res => {
                        this.loading = false

                        // 开通成功
                        if (res.result === null && res.status && res.code === '200') {
                            this.$emit('refresh')
                            return
                        }

                        // 斑豆异常处理
                        if (res.message.indexOf('斑豆不足') > -1) {
                            this.messageDialog = {
                                visible: true,
                                rightBtnName: '去做任务',
                                leftBtnName: '取消',
                                leftBtnMethod: () => {
                                    this.messageDialog.visible = false
                                },
                                rightBtnMethod: () => {
                                    this.messageDialog.visible = false

                                    // 跳转斑豆任务
                                    this.$jsBridge.callBackHandler('pushBandouCenterPage')
                                },
                                title: '',
                                content: res.message
                            }
                        }

                        // 错误状态码处理
                        if (res.code === '666') {
                            Toast.fail(res.message)
                        }
                    })
                },
                title: '',
                content: '是否确认开通VIP题库？'
            }
        },
        // 金钱开通方式
        moneyOpenModel () {
            // 除了IOS设备都需要登陆
            if (!this.IOS && !this.userInfo.userId) {
                this.$jsBridge.callBackHandler('loginUserV2')
                return
            }

            this.loading = true

            this.$api.vipPayOpen({ currentUserId: this.userInfo.userId }).then(res => {
                this.loading = false
                // 正常支付流程
                if (res.code === '200' && res.status) {
                    // 判断是否IOS && 苹果支付
                    if (this.IOS) {
                        // app埋点
                        this.$jsBridge.callBackHandler('onEventObjectUM', {
                            eventId: 'e_vip_pay',
                            map: JSON.stringify({ payType: 3 })
                        })

                        // 兼容ios
                        this.$jsBridge.callBackHandler('setApplePayType', { payType: 4 })

                        // 唤起苹果支付
                        this.$jsBridge.callBackHandler('applyPay', {
                            orderId: res.result,
                            productId: this.openData.productId
                        })
                        return
                    }

                    this.$router.push({
                        name: 'pay',
                        query: {
                            payId: res.result,
                            money: this.openData.payConPrice > 0 ? this.openData.payConPrice : this.openData.payOrigPrice,
                            type: '1',
                            headShow: this.headVisible
                        }
                    })
                    return
                }
                // 错误状态码处理
                if (res.code === '701') {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '去支付',
                        leftBtnName: '取消',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false
                            this.$router.push({
                                name: 'vipOrderDetail',
                                query: { id: res.result, headShow: '1' }
                            })
                        },
                        title: '',
                        content: '您有VIP订单未支付'
                    }
                }

                // 斑豆异常处理
                if (res.message.indexOf('斑豆不足') > -1) {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '去做任务',
                        leftBtnName: '取消',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false

                            // 跳转斑豆任务
                            this.$jsBridge.callBackHandler('pushBandouCenterPage')
                        },
                        title: '',
                        content: res.message
                    }
                }

                // 错误状态码处理
                if (res.code === '666') {
                    Toast.fail(res.message)
                }
            })
        },
        // 分享开通方式
        shareOpenModel () {
            // 分享开通需要登陆
            if (!this.userInfo.userId) {
                this.$jsBridge.callBackHandler('loginUserV2')
                return
            }

            // 标题
            let title = this.openData.title
            // 内容
            let content = this.openData.content
            // 分享链接
            let shareUrl = this.openData.link
            // 图片链接
            let imageUrl = this.openData.image
            // 页面编码
            let pageCode = 'question-bank'

            // 唤起分享
            this.$jsBridge.callBackHandler('share', { title, content, shareUrl, imageUrl, pageCode })
        },
        // 开通
        submit () {
            // H5标记不能购买
            if (this.H5) {
                this.linkApp()
                return
            }

            // app埋点
            this.$jsBridge.callBackHandler('onEventUM', { eventId: 'e_vip_button_click' })

            // 判断是否升级提示
            if (this.vipData.uploadAppFlag) {
                Toast.fail('VIP服务已升级，请升级APP获取更多服务！')
                return
            }

            // 班豆支付
            if (this.openData.openMode === 3) {
                this.beanOpenModel()
            }
            // 金钱支付
            if (this.openData.openMode === 2) {
                this.moneyOpenModel()
            }
            // 分享激活
            if (this.openData.openMode === 1) {
                this.shareOpenModel()
            }
        },
        // 支付回调
        payCallback (v) {
            // 未登录购买刷新数据
            if (Number(v) === 1 && !this.userInfo.userId) {
                this.$emit('refresh')
                return
            }

            // 跳转支付结果页
            this.$router.push({ name: 'payResult', query: { result: v, headShow: '1' } })
        },
        // 分享回调
        shareCallback () {
            // 判断车型 || 是否分享开通模式
            if (Number(this.carType) !== 1 || Number(this.openData.openMode) !== 1) {
                return
            }

            this.loading = true
            this.$api.vipShareOpen({ shareRecordId: this.openData.shareRecordId, times: '1' }).then(res => {
                this.loading = false
                if (res.status) {
                    if (res.result === 0) {
                        this.$emit('refresh')
                    } else {
                        Toast.success('分享成功')
                    }
                }
            })
        },
        // 获取分享配置信息
        getSetting () {
            this.$api.getAdSetting({ code: 'question-bank' }).then(res => {
                if (res.status && res.result) {
                    this.shareData = res.result
                }
            })
        },
        // 检查车型
        checkCarType () {
            const carTypeName = this.$store.getters.carTypeName

            if (Number(this.carType) !== 1 && this.$jsBridge.hasNativeMethod('pushQuestionBankSettingPage')) {
                this.messageDialog = {
                    visible: true,
                    rightBtnName: '切换题库',
                    leftBtnName: '我知道了',
                    leftBtnMethod: () => {
                        this.messageDialog.visible = false
                    },
                    rightBtnMethod: () => {
                        this.messageDialog.visible = false

                        // 进入设置题库页面
                        this.$jsBridge.callBackHandler('pushQuestionBankSettingPage')
                    },
                    title: '温馨提示',
                    content: `该服务现仅适用于小车学员，您当前车型-${carTypeName[this.carType]}，是否需切换回小车题库？`
                }
            }
        },
        // 初始化
        init () {
            // app埋点
            this.$jsBridge.callBackHandler('onEventUM', { eventId: 'e_vip_detail_visit' })

            // 设置vip开通数据
            this.openData = JSON.parse(JSON.stringify(this.vipData.examVipSettingDTO))

            // 设置H5标记
            this.H5 = this.$route.query.shareType === 'h5'

            // 设置app类型
            this.appType = this.$jsBridge.callBackHandler('getAppType') || (typeof this.$route.query.appType === 'object' ? this.$route.query.appType[0] : this.$route.query.appType)

            // 设置分享显示
            this.shareVisible = !this.H5

            // 设置头部显示
            this.headVisible = this.$route.query.headShow || '1'

            // 暴露支付回调方法
            this.$jsBridge.registerHandler('payCallback', this.payCallback)

            // 暴露分享回调方法
            this.$jsBridge.registerHandler('shareCallback', this.shareCallback)
        },
        // 跳转vip套餐 vipChange
        goVipPackage () {
            this.$router.replace({
                name: 'vipPackageV2',
                query: { vipChange: '1', ...this.$route.query }
            })
        },
        // 监听滚动条位置
        bindScroll () {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            // 校验可视区域 是否离开中间切换的按钮
            if (this.$refs['detail-item']) {
                this.isShowFooter = scrollTop > (this.$refs['detail-item'].offsetTop - 70)
            }
        },
        // 打开会员开通协议页面
        handleOpenMember () {
            this.$jsBridge.callBackHandler('pushSecondaryPage', {
                secondaryUrl: `${window.location.origin}/ui/h5/agreement/memberPartyInfo`
            })
        }
    },
    destroyed () {
        // 离开页面 删掉滚动事件
        window.removeEventListener('scroll', this.bindScroll)
    },
    mounted () {
        this.init()
        this.checkCarType()
        // 给页面添加滚动事件
        window.addEventListener('scroll', this.bindScroll)
    },
    created () {
        this.getSetting()
    },
    data () {
        return {
            // 支付教程显示
            iphonePayCourseVisible: false,
            // vip开通数据
            openData: {},
            // 分享数据
            shareData: {},
            // loading
            loading: false,
            // 显示分享
            shareVisible: false,
            // 头部显示
            headVisible: '',
            // app类型 1-定制版 2-学时版
            appType: '',
            // 苹果标记
            IOS: !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            // h5标记
            H5: false,
            // 弹窗数据
            messageDialog: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            // 是否展示底部 商品切换 以及价格展示状态
            isShowFooter: false
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "./goods.scss";
    .wrapper-open {
        background: #FEECDE;

        .pay-course {
            text-decoration: underline;
            font-size: 13px;
            color: #A6431B;
            text-align: right;
            line-height: 1;
        }

        .van-button {
            height: 100%;
            border: none;
        }

        .van-button__loading {
            margin: 0 auto;
            vertical-align: middle;
        }

        .header {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            display: flex;
            z-index: 2;
            align-items: center;
            justify-content: space-between;
            height: 60px;
            background: #ffffff;

            .header-main {
                font-size: 18px;

                font-weight: bold;
                color: #333333;
            }

            .header-share {
                position: absolute;
                height: 60px;
                display: flex;
                align-items: center;
                right: 50px;
                font-size: 0;
                line-height: 1;

                img {
                    width: 24px;
                }
            }

            .header-left, .header-right {
                display: flex;
                padding: 15px 10px;
                font-size: 0;
                line-height: 1;

                img {
                    width: 24px;
                    height: 24px;
                }
            }
        }

        .header-pre {
            height: 60px;
        }

        .bg {
            line-height: 1;

            .bg-item {
                position: relative;
                z-index: 1;
            }

            .detail-item {
                position: relative;
                box-sizing: border-box;
                width: 375px;

                .detail-item-wrap {
                    display: flex;
                    flex-wrap: wrap;
                    padding: 70px 10px 0;
                    position: absolute;
                    box-sizing: border-box;
                    width: 375px;
                }

                .detail-click {
                    position: relative;
                    z-index: 2;
                    display: inline-block;
                    flex: 25%;
                    height: 55px;
                    margin-bottom: 15px;
                }

                img {
                    width: 375px;
                }
            }

            .money {
                font-weight: bold;
                width: 100%;
                line-height: 48px;
                text-align: center;
                position: absolute;
                bottom: 25px;
                color: #ffffff;
                font-size: 24px;
            }

            img {
                width: 375px;
            }
        }

        .video-wrap {
            position: relative;

            & img:nth-child(2) {
                left: 50%;
                top: 98px;
                width: 325px;
                transform: translateX(-50%);
                position: absolute;
            }

            & img:nth-child(3) {
                position: absolute;
                left: 50%;
                bottom: 107px;
                width: 45px;
                height: 45px;
                transform: translateX(-50%);
            }
        }

        .footer-pre {
            height: 49px;
        }

        .footer {
            z-index: 2;
            position: fixed;
            bottom: 0;
            width: 100%;
            height: 49px;
            border-top: 1px solid #EEEEEE;
            background: #ffffff;
            display: flex;
            justify-content: space-between;

            .buoy {
                width: 110px;
                top: -26px;
                left: 20px;
                position: absolute;
            }

            span {
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .first {
                flex: 1;
                overflow: hidden;
                flex-direction: column;
                font-weight: 600;
                box-sizing: border-box;
                color: rgba(255, 80, 80, 1);
                justify-content: flex-start;
                line-height: 1;
                align-items: flex-start;
                padding: 0 0 0 58px;
                white-space: nowrap;
                text-overflow: ellipsis;
                .left {
                    color: #FF5050;
                    font-size: 24px;
                }

                .flag{
                    margin: 5px 0 2px 0;
                    padding: 2px 4px;
                    border: 1px solid #FF5050;
                    display: inline-block;
                    font-size: 13px;
                    font-weight: 400;
                    color: #FF5050;
                }
                .money{
                    display: flex;
                }

                .main {
                    position: relative;
                    top: 1px;
                    margin-right: 8px;
                    color: #333333;
                    font-weight: normal;
                    font-size: 15px;

                }

                .right {
                    position: relative;
                    top: 1px;
                    color: #999999;
                    font-weight: normal;
                    font-size: 15px;
                    text-decoration: line-through;
                }
            }

            .second {
                flex: 1;
                font-size: 17px;

                font-weight: bold;
                color: #333333;

                b {
                    font-size: 13px;
                    font-weight: normal;
                }
            }

            .third {
                width: 80px;
                background: #FFEED2;
                font-size: 18px;

                font-weight: bold;
                color: #D4A36B;
            }

            .fourth {
                border-radius: 0;
                width: 110px;
                background: #F5DDB6;
                font-size: 17px;

                font-weight: bold;
                color: #A86F2F;
            }

            .recovery {
                border-radius: 0;
                width: 110px;
                background: #FFEED2;
                font-size: 17px;

                font-weight: bold;
                color: #A86F2F;
            }
        }

        .rule {
            margin: 10px auto 15px;
            width: 355px;
            background: #FFF8F2;
            border-radius: 5px;
            padding-bottom: 20px;

            .rule-title {
                position: relative;
                top: -9px;
                display: block;
                margin: 0 auto 5px;
                width: 152px;
                height: 60px;
            }

            .rule-item {
                padding: 0 15px;

                .rule-item-title {
                    background: url("~@/assets/vip/icon_wt01@2x.png") no-repeat left 2px;
                    background-size: 16px;

                    padding-left: 26px;
                    line-height: 22px;
                    font-size: 15px;
                    font-weight: 600;
                    color: #A6431B;
                }

                .rule-item-content {
                    word-break: break-word;
                    white-space: pre-line;
                    margin-top: 10px;
                    padding-left: 26px;
                    font-size: 12px;
                    font-weight: 400;
                    color: #000000;
                    line-height: 21px;

                    b {
                        color: #FF5050;
                    }
                }
            }

            .rule-item + .rule-item {
                margin-top: 20px;
            }
        }

        .btn-none-buy {
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 1;
            font-size: 15px;
            font-weight: bold;
            color: #999999;
            background: #F0F0F0;
        }

        .change-page {
            box-sizing: border-box;
            padding: 10px;
            display: flex;
            z-index: 2;
            justify-content: space-between;
            position: fixed;
            width: 100%;
            bottom: 49px;
            background: #fff;

            .item {
                box-sizing: border-box;
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 173px;
                height: 55px;
                font-size: 15px;
                font-weight: 600;
                color: #FFFFFF;
                border-radius: 5px;
                background: #000000;
                border: 1px solid #000000;
            }

            .icon-active {
                position: absolute;
                right: -1px;
                bottom: -1px;
                width: 40px;
                height: 18px;
            }

            .icon-xsrm {
                position: absolute;
                right: -1px;
                top: -8px;
                width: 60px;
            }

            .item:nth-child(2) {
                background: #ffffff;
                border: 1px solid #C0C1C4;
                color: #6A220D;
            }
        }

        .change-page-pre {
            height: 70px;
        }

        .f-s-18 {
            font-size: 18px;
        }

        .f-s-15 {
            position: relative;
            top: 2px;
            font-weight: normal;
            margin-left: 5px;
            font-size: 15px;
        }

    }
    .no-scroll {
        height: 100vh;
        overflow: hidden;
    }
    .fade {
        transition: all 0.3s ease;
        &.hide{
            opacity: 0;
            visibility: hidden;
            transform: translateY(100px);
        }
        &.show{
            opacity: 1;
            visibility: unset;
            transform: translateY(0px);
        }
    }

    .new{
        z-index: 1 !important;
    }
    .new::after{
        animation: rotate .8s infinite;
        position: absolute;
        right: 15px;
        top: -10px;
        width: 27px;
        height: 21px;
        content: '';
        display: block;
        background: url("~@/assets/vipV3/icon_new.png") no-repeat 0% / 100%;
    }

    @keyframes rotate {
        0% { transform: rotate(-10deg) }
        25% { transform: rotate(0) }
        50% { transform: rotate(10deg) }
        75% { transform: rotate(0deg) }
        100% { transform: rotate(-10deg) }
    }
    .tips {
        display: flex;
        align-items: center;
        padding: 10px 10px 20px;
        .mamber-info {
            flex: 1;
            color: #666;
            font-size: 13px;
            a {
                color: #A6431B;
            }
        }
    }
    
</style>
